import { Input, type FormItemProps } from 'antd';

import { FormItemField } from '../../FormItemField';

type InputFieldProps = {
  label: string;
  fieldName: string | number | (string | number)[];
  rules?: FormItemProps['rules'];
  required?: boolean;
  disabled: boolean;
  maxLength?: number;
  size?: 'small' | 'middle' | 'large';
  validateStatus?: 'success' | 'warning' | 'error' | 'validating';
};

export const InputField = ({
  label,
  fieldName,
  rules,
  required,
  disabled,
  maxLength,
  size = 'middle',
  validateStatus,
}: InputFieldProps) => (
  <FormItemField
    label={label}
    fieldName={fieldName}
    rules={rules}
    required={required}
    validateStatus={validateStatus}
  >
    <Input disabled={disabled} maxLength={maxLength} size={size} />
  </FormItemField>
);
